import { useAuthStore, type AuthUser } from '@/features/auth/store/auth-store';

/**
 * Shared hook that provides the current user and logout action.
 *
 * Centralizes auth-store access so that shared components and other features
 * go through @/shared/hooks/ instead of importing @/features/auth/store directly.
 * This is the same bridging pattern used by usePermissions().
 */
export function useCurrentUser(): {
  user: AuthUser | null;
  isAuthenticated: boolean;
  logout: () => void;
} {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const logout = useAuthStore((s) => s.logout);
  return { user, isAuthenticated, logout };
}
